import { useQuery } from '@hooks/reactQuery';

import { map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { findAssetsByAssetId } from '@api/assets';

import { extractQueryParams } from '@utils/common';

import { EDataType } from '@enums/map';

import { ASSETS_FIND } from '@constants/queryKeys';

export const useQueryFindAssetsByAssetId = (searchValue: string) => {
	const { markerType } = useAppSelector(map);
	const isAssets = markerType === EDataType.assets;

	const {
		data: assetsBySearch,
		isInitialLoading,
	} = useQuery({
		queryKey: [
			ASSETS_FIND,
			searchValue,
		],
		queryFn: extractQueryParams(findAssetsByAssetId),
		refetchOnWindowFocus: false,
		enabled: [!!searchValue, isAssets],
	});

	return {
		assetsBySearch: assetsBySearch?.items || [],
		isLoadingAssetsBySearch: isInitialLoading,
	};
};
